// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Ju-3kyDghk7l_nWU-2Vf1:after{position:absolute;content:\"\";left:2.4rem;right:2.4rem;bottom:0;border-bottom:1px solid #e5e5e5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "Ju-3kyDghk7l_nWU-2Vf1"
};
module.exports = ___CSS_LOADER_EXPORT___;
